
import React, { useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import FactoryIcon from '@mui/icons-material/Factory';
import HistoryIcon from '@mui/icons-material/History';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Inventory2 as InventoryIcon,
  ShoppingCart as ShoppingCartIcon,
  ShoppingCart as SalesIcon,
  ShoppingBag as PurchaseIcon,
  People as CustomersIcon,
  LocalShipping as SuppliersIcon,
  Assessment as ReportsIcon,
  Settings as SettingsIcon,
  ExpandLess,
  ExpandMore,
  TrainOutlined,
  LocationCity,
  Logout as LogoutIcon,
  Person as PersonIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  
} from "@mui/icons-material";
import BuildIcon from "@mui/icons-material/Build";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const drawerWidth = 250;

const menuGroups = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard",
  },

  {
    title: "Masters",
    icon: <SettingsIcon />,
    children: [


 {
        title: "Coach",
        path: "/coach-master",
        icon: <TrainOutlined />,
      },

      {
        title: "Coach Base",
        path: "/Railway",
        icon: <LocationCity />,
      },

       {
        title: "Coach Type",
        path: "/coachtype",
        icon: <TrainOutlined />,
      },
      
      {
        title: "Repair Type",
        path: "/repairtype",
        icon: <BuildCircleIcon   />,
      },
     
      {
        title: "Make",
        path: "/make",
        icon: <FactoryIcon/>,
      },

      {
        title: "Shop",
        path: "/shop",
        icon: <BuildIcon/>,
      },
      
    ],
  },

  {
    title: "Transactions",
    icon: <ShoppingCartIcon />,
    children: [
      {
        title: "Yard",
        path: "/yard",
        icon: <SalesIcon />,
      },
      
       {
        title: "Lift",
        path: "/lift",
        icon: <SalesIcon />,
      },
      {
        title: "Shell",
        path: "/shell",
        icon: <PurchaseIcon />,
      },

      {
        title: "Inspection",
        path: "/inspection",
        icon: <PurchaseIcon />,
      },

      {
        title: "PDC",
        path: "/pdc",
        icon: <PurchaseIcon />,
      },

       {
        title: "Technical Clearance",
        path: "/technical-clearance",
        icon: <PurchaseIcon />,
      },

    ],
  },

  

  {
    title: "Reports",
    icon: <ReportsIcon />,
    children: [

      {
  title: 'Coach All History',
  path: '/coach-all-history',
  icon: <HistoryIcon />,
},
{
  title: 'Coach Conversion History',
  path: '/coach-history',
  icon: <HistoryIcon />,
},

      {
        title: "Daily Report",
        path: "/reports/daily",
      },


      {
        title: "10 Days Report",
        path: "/reports/10days",
      },
      
      {
        title:"Monthly Report",
        path: "/reports/monthly",
      },
    ],
  },
];

function MainLayout() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();

  const { user, logout } = useAuth();

  const [mobileOpen, setMobileOpen] = useState(false);

  const [openMenus, setOpenMenus] = useState({
    Masters: true,
    Transactions: true,
    Reports: false,
  });

  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleMenuToggle = (title) => {
    setOpenMenus((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isGroupActive = (children) => {
    return children?.some(
      (item) => location.pathname === item.path
    );
  };

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "#ffffff",
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          height: 70,
          display: "flex",
          alignItems: "center",
          px: 2.5,
          gap: 1.5,
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontWeight: 800,
            fontSize: 20,
            background:
              "linear-gradient(135deg, #2563eb, #7c3aed)",
          }}
        >
          S
        </Box>

        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={800}
            lineHeight={1}
          >
            MWS
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
          >
           CIS
          </Typography>
        </Box>
      </Box>

      {/* Menu */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          py: 1.5,
          px: 1.2,
        }}
      >
        <List disablePadding>
          {menuGroups.map((group) => {
            const hasChildren = Boolean(group.children);

            if (!hasChildren) {
              return (
                <ListItemButton
                  key={group.title}
                  component={NavLink}
                  to={group.path}
                  onClick={() => {
                    if (isMobile) {
                      setMobileOpen(false);
                    }
                  }}
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    minHeight: 46,
                    color: isActive(group.path)
                      ? "#2563eb"
                      : "#475569",

                    backgroundColor: isActive(group.path)
                      ? "#eff6ff"
                      : "transparent",

                    "&:hover": {
                      backgroundColor: "#f8fafc",
                    },

                    "&.active": {
                      backgroundColor: "#eff6ff",
                      color: "#2563eb",
                      fontWeight: 700,
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 42,
                      color: "inherit",
                    }}
                  >
                    {group.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={group.title}
                    primaryTypographyProps={{
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  />
                </ListItemButton>
              );
            }

            const groupOpen =
              openMenus[group.title] ||
              isGroupActive(group.children);

            return (
              <React.Fragment key={group.title}>
                <ListItemButton
                  onClick={() =>
                    handleMenuToggle(group.title)
                  }
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    minHeight: 46,
                    color: isGroupActive(group.children)
                      ? "#2563eb"
                      : "#475569",

                    "&:hover": {
                      backgroundColor: "#f8fafc",
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 42,
                      color: "inherit",
                    }}
                  >
                    {group.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={group.title}
                    primaryTypographyProps={{
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  />

                  {groupOpen ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItemButton>

                <Collapse
                  in={groupOpen}
                  timeout="auto"
                  unmountOnExit
                >
                  <List
                    disablePadding
                    sx={{
                      ml: 2,
                      borderLeft: "1px solid #e2e8f0",
                    }}
                  >
                    {group.children.map((item) => (
                      <ListItemButton
                        key={item.title}
                        component={NavLink}
                        to={item.path}
                        onClick={() => {
                          if (isMobile) {
                            setMobileOpen(false);
                          }
                        }}
                        sx={{
                          ml: 1,
                          borderRadius: 2,
                          minHeight: 42,
                          color: isActive(item.path)
                            ? "#2563eb"
                            : "#64748b",

                          backgroundColor: isActive(
                            item.path
                          )
                            ? "#eff6ff"
                            : "transparent",

                          "&:hover": {
                            backgroundColor: "#f8fafc",
                          },

                          "&.active": {
                            color: "#2563eb",
                            backgroundColor: "#eff6ff",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 36,
                            color: "inherit",
                          }}
                        >
                          {item.icon || (
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                background:
                                  "currentColor",
                              }}
                            />
                          )}
                        </ListItemIcon>

                        <ListItemText
                          primary={item.title}
                          primaryTypographyProps={{
                            fontSize: 13,
                            fontWeight: 600,
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            );
          })}
        </List>
      </Box>

      {/* Bottom User */}
      <Box>
        <Divider />

        <Box
          sx={{
            p: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
          }}
        >
          <Avatar
            sx={{
              width: 38,
              height: 38,
              background:
                "linear-gradient(135deg, #2563eb, #7c3aed)",
            }}
          >
            {user?.name?.charAt(0)?.toUpperCase() || "U"}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="body2"
              fontWeight={700}
              noWrap
            >
              {user?.name || "User"}
            </Typography>

            <Typography
              variant="caption"
              color="text.secondary"
              noWrap
            >
              {user?.role || "User"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />

      {/* Top AppBar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: {
            md: `calc(100% - ${drawerWidth}px)`,
          },
          ml: {
            md: `${drawerWidth}px`,
          },
          backgroundColor: "#ffffff",
          color: "#0f172a",
          borderBottom: "1px solid #e5e7eb",
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            minHeight: "70px !important",
            px: { xs: 1.5, sm: 2.5 },
          }}
        >
          {isMobile && (
            <IconButton
              onClick={handleDrawerToggle}
              edge="start"
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                fontSize: {
                  xs: "1rem",
                  sm: "1.15rem",
                },
              }}
            >
              {location.pathname === "/dashboard"
                ? "Dashboard"
                : "Machenical Workshop, Gorakhpur"}
            </Typography>

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              Coach Information System
            </Typography>
          </Box>

          {/* User Menu */}
          <IconButton
            onClick={handleUserMenuOpen}
            sx={{
              borderRadius: 2,
              px: 1,
            }}
          >
            <Avatar
              sx={{
                width: 38,
                height: 38,
                background:
                  "linear-gradient(135deg, #2563eb, #7c3aed)",
              }}
            >
              {user?.name?.charAt(0)?.toUpperCase() || "U"}
            </Avatar>

            <Box
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                },
                textAlign: "left",
                ml: 1,
              }}
            >
              <Typography
                variant="body2"
                fontWeight={700}
              >
                {user?.name || "User"}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
              >
                {user?.role || "User"}
              </Typography>
            </Box>

            <KeyboardArrowDownIcon
              sx={{
                ml: 0.5,
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            />
          </IconButton>

          <Menu
            anchorEl={userMenuAnchor}
            open={Boolean(userMenuAnchor)}
            onClose={handleUserMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleUserMenuClose}>
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              My Profile
            </MenuItem>

            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon
                  fontSize="small"
                  color="error"
                />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Desktop Drawer */}
      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              borderRight: "1px solid #e5e7eb",
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: "100%",
            md: `calc(100% - ${drawerWidth}px)`,
          },
          minWidth: 0,
          backgroundColor: "#f8fafc",
          minHeight: "100vh",
        }}
      >
        <Toolbar sx={{ minHeight: "70px !important" }} />

        <Box
          sx={{
            p: {
              xs: 1.5,
              sm: 2,
              md: 3,
            },
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default MainLayout;
